<div class="width-95-percent">
  <div class="mb-10 gap-10 flex justify-end">
    <div class="pt-20">Role View:</div>
    <div class="container radio-button radio-bg" style="margin:0px">
      <input id="internal" name="roleView" type="radio" [(ngModel)]="currentRole" [value]="2" ng-control="options" />
      <label class="gray-300 click-white" for="internal">Internal</label>
    </div>
    <div class="container radio-button radio-bg" style="margin:0px">
      <input id="external" name="roleView" [(ngModel)]="currentRole" type="radio" [value]="1" ng-control="options" />
      <label class="gray-300 click-white" for="external">External</label>
    </div>
  </div>
</div>

<!-- <div id="rolesDiv">
Role View:
<div class="inline">
  <input name="RoleView" id="internal" class="radio-roleview" ng-control="options" type="radio" [value]="2"
    [(ngModel)]="currentRole" />
    <label for="internal" class="radio-roleview padding5">Internal</label>
  </div>
  <div class="inline">
    <input name="RoleView" id="external" ng-control="options" type="radio" [value]="1" [(ngModel)]="currentRole" />
    <label for="external" class="radio-roleview padding5">External</label>
  </div>
</div> -->
<div class="pb-20">
  <div class="flex gap-20 roles width-95-percent">
    @for (item of getList(currentRole); track item) {
      <div class="border border-gray-600 p-20 rounded-4 hover-shadow" id="CompreMySummaryViewUL">
        <div class="top-color"></div>
        <div class="">
          @for (subitem of item.roles; track subitem) {
            <div class="mb-5 flex">
              @if (subitem?.hasRole == 'Y') {
                <i class="fa fa-check-circle font-orange">
                </i>
              }
              @if (subitem?.hasRole == 'N') {
                <i class="fa fa-minus-circle font-gray-600">
                </i>
              }
          <div class="pl-5" [ngClass]="{
              'font-orange': subitem?.hasRole == 'Y',
              'font-black regular': subitem?.hasRole == 'N'
            }">
                {{ subitem.roleName }}
              </div>
            </div>
          }
        </div>
        <hr />
        @for (subitem of item.entitlements; track subitem) {
          <div>
            @if (subitem.hasEntitlement == 'Y') {
              <div class="color-green font-18 flex mb-5">
                <i class="fa fa-check-circle mt-5"></i>
                <div class="ml-10">{{ subitem.entitlementName }}</div>
              </div>
            }
            @if (subitem.hasEntitlement == 'N') {
              <div class="color-red font-18 flex mb-5">
                <i class="fa fa-times-circle mt-5"></i>
                <div class="ml-10">{{ subitem.entitlementName }}</div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
